import { useCreditFacilityRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { CreditFacilityData } from "gen/model/creditFacilityData";
import { CreditFacilityStateMachineFieldsEnum } from "gen/model/creditFacilityStateMachineFieldsEnum";
import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs, PageTabsStatus } from "shared/components/layout/PageTabs";
import { useFeatureFlagActive } from "shared/hooks/useFeatureFlag";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export interface CreditFacilityTabProps {
  creditFacility: CreditFacilityData | undefined;
}

export const CreditFacilityPageTabs: React.FC = () => {
  const { t } = useTranslation(["creditFacility"]);
  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();
  const expensesIsActive = useFeatureFlagActive("credit_facility_expenses");
  const { data: creditFacility } = useCreditFacilityRetrieveSuspense(
    fundFamilyId,
    creditFacilityId,
    {
      query: {
        refetchOnMount: "always",
      },
    },
  );
  if (creditFacility.state === CreditFacilityStateMachineFieldsEnum.draft) {
    return (
      <Navigate
        replace={true}
        to={
          rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .creditFacilities({})
            .creditFacility({ creditFacilityId }).$
        }
      />
    );
  }

  const tabProps: CreditFacilityTabProps = { creditFacility };

  const hiddenTabs: PageTabsStatus = {
    creditFacilitiesCreditFacilityPrincipal: false,
    creditFacilitiesCreditFacilityExpenses: !expensesIsActive,
    creditFacilitiesCreditFacilityBorrowingBase: false,
  };

  return (
    <PageContent>
      <PageHeader title={t("creditFacility:title")} />
      <PageBody key={creditFacilityId}>
        <PageTabs context={tabProps} hiddenTabs={hiddenTabs} />
      </PageBody>
    </PageContent>
  );
};
